import React from 'react'

export default function HawkEye({ hawkEyeSrc = '' })  {
  let style = {
    margin : '0 auto',
    backgroundColor : '#FFF',
    textAlign : 'center',
    padding : '20'
  }
  let iframeStyle = {
    backgroundColor : '#FFF'
  }
  return (
    <section style={ style }>
      <iframe id="hawkeye" name="hawkeye" src={ hawkEyeSrc } style={ iframeStyle }
        frameBorder="0" width="630" height="750" marginWidth="0" marginHeight="0" />
    </section>
  )
}



// WEBPACK FOOTER //
// ../app/components/gamepackage/cricket/HawkEye.jsx